module.exports = __webpack_public_path__ + "img/8f44348.jpg";